import { Deserializable } from '../protocols/deserializable';
import { UniquelyIdentifiable } from '../protocols/uniquely-identifiable';
import { Role } from './role';

export class UserRole implements Deserializable, UniquelyIdentifiable {
  roleId: number;
  role!: Role;

  constructor(roleId: number) {
    this.roleId = roleId;
  }

  onDeserialize(): void {}

  getUniqueIdentifier(): string {
    return `${this?.roleId}` + `${this.role?.getUniqueIdentifier()}`;
  }
}
